/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ waitingStatus: NonNullable<unknown> }} Task_Waiting_Status_LabelInputs */

const en_task_waiting_status_label = /** @type {(inputs: Task_Waiting_Status_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.waitingStatus === "awaiting_additional_data") return /** @type {LocalizedString} */ (`Awaiting additional data`);
	if (i?.waitingStatus === "awaiting_response") return /** @type {LocalizedString} */ (`Awaiting response`);
	if (i?.waitingStatus === "awaiting_documents") return /** @type {LocalizedString} */ (`Awaiting documents`);
	if (i?.waitingStatus === "awaiting_third_party_signature") return /** @type {LocalizedString} */ (`Awaiting third-party signature`);
	if (i?.waitingStatus === "next_contact_scheduled") return /** @type {LocalizedString} */ (`Next contact scheduled`);
	if (i?.waitingStatus === "awaiting_dvc") return /** @type {LocalizedString} */ (`Awaiting DVC`);
	if (i?.waitingStatus === "awaiting_payment") return /** @type {LocalizedString} */ (`Awaiting payment`);
	if (i?.waitingStatus === "payment_in_progress") return /** @type {LocalizedString} */ (`Payment in progress`);
	if (i?.waitingStatus === "payment_overdue") return /** @type {LocalizedString} */ (`Payment overdue`);
	if (i?.waitingStatus === "payment_completed") return /** @type {LocalizedString} */ (`Payment completed`);
	if (i?.waitingStatus === "renegotiating") return /** @type {LocalizedString} */ (`Renegotiating`);
	return /** @type {LocalizedString} */ (`${i?.waitingStatus}`)
	
};

const pt_br2_task_waiting_status_label = /** @type {(inputs: Task_Waiting_Status_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.waitingStatus === "awaiting_additional_data") return /** @type {LocalizedString} */ (`Aguardando dados adicionais`);
	if (i?.waitingStatus === "awaiting_response") return /** @type {LocalizedString} */ (`Aguardando retorno`);
	if (i?.waitingStatus === "awaiting_documents") return /** @type {LocalizedString} */ (`Aguardando documentos`);
	if (i?.waitingStatus === "awaiting_third_party_signature") return /** @type {LocalizedString} */ (`Aguardando assinatura terceiro`);
	if (i?.waitingStatus === "next_contact_scheduled") return /** @type {LocalizedString} */ (`Próximo contato agendado`);
	if (i?.waitingStatus === "awaiting_dvc") return /** @type {LocalizedString} */ (`Aguardando DVC`);
	if (i?.waitingStatus === "awaiting_payment") return /** @type {LocalizedString} */ (`Aguardando pagamento`);
	if (i?.waitingStatus === "payment_in_progress") return /** @type {LocalizedString} */ (`Pagamento em andamento`);
	if (i?.waitingStatus === "payment_overdue") return /** @type {LocalizedString} */ (`Pagamento em atraso`);
	if (i?.waitingStatus === "payment_completed") return /** @type {LocalizedString} */ (`Pagamento finalizado`);
	if (i?.waitingStatus === "renegotiating") return /** @type {LocalizedString} */ (`Em renegociação`);
	return /** @type {LocalizedString} */ (`${i?.waitingStatus}`)
	
};

/**
* | waitingStatus | output |
* | --- | --- |
* | "awaiting_additional_data" | "Awaiting additional data" |
* | "awaiting_response" | "Awaiting response" |
* | "awaiting_documents" | "Awaiting documents" |
* | "awaiting_third_party_signature" | "Awaiting third-party signature" |
* | "next_contact_scheduled" | "Next contact scheduled" |
* | "awaiting_dvc" | "Awaiting DVC" |
* | "awaiting_payment" | "Awaiting payment" |
* | "payment_in_progress" | "Payment in progress" |
* | "payment_overdue" | "Payment overdue" |
* | "payment_completed" | "Payment completed" |
* | "renegotiating" | "Renegotiating" |
* | * | "{waitingStatus}" |
*
* @param {Task_Waiting_Status_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_waiting_status_label = /** @type {((inputs: Task_Waiting_Status_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Waiting_Status_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_waiting_status_label(inputs)
	return pt_br2_task_waiting_status_label(inputs)
});